import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container pagination__container" }
const _hoisted_2 = { class: "pagination__block" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon pagination__arrow-icon",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#chevron-right-2" })
], -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon pagination__arrow-icon",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#chevron-left" })
], -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 3,
  class: "pagination__item pagination__dots"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "pagination__item pagination__num active" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 4,
  class: "pagination__item pagination__dots"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon pagination__arrow-icon",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#chevron-right" })
], -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("svg", {
  class: "sprite-icon pagination__arrow-icon",
  width: "16",
  height: "16"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "/img/sprite.svg#chevron-right-2" })
], -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = { class: "pagination__show p-d-none p-d-md-block" }
const _hoisted_17 = { class: "select select--small" }
const _hoisted_18 = { class: "select__label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_app_dropdown = _resolveComponent("app-dropdown")!

  return (_ctx.total > 0)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["pagination app-pagination", _ctx.isTransparent && 'is-transparent']),
        id: "c-app-pagination"
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.hasHiddenPagesBeforeCurrentPage)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "pagination__item pagination__arrow-first",
                  href: "#",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.goToFirstPage()), ["stop","prevent"]))
                }, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.hasHiddenPagesBeforeCurrentPage)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "pagination__item pagination__arrow-prev",
                  href: "#",
                  onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.goToPreviousPage()), ["stop","prevent"]))
                }, _hoisted_6))
              : _createCommentVNode("", true),
            (_ctx.canShowFirstPage)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 2,
                  class: "pagination__item pagination__num",
                  href: "#",
                  onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.goToPage(1)), ["stop","prevent"]))
                }, " 1 "))
              : _createCommentVNode("", true),
            (_ctx.hasHiddenPagesBeforeCurrentPage)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, " ... "))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fewItemsBeforeCurrentPage, (page) => {
              return (_openBlock(), _createElementBlock("a", {
                class: "pagination__item pagination__num",
                href: "#",
                key: page,
                onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["stop","prevent"])
              }, _toDisplayString(page), 9, _hoisted_8))
            }), 128)),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.currentPage), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fewItemsAfterCurrentPage, (page) => {
              return (_openBlock(), _createElementBlock("a", {
                class: "pagination__item pagination__num",
                href: "#",
                key: page,
                onClick: _withModifiers(($event: any) => (_ctx.goToPage(page)), ["stop","prevent"])
              }, _toDisplayString(page), 9, _hoisted_10))
            }), 128)),
            (_ctx.hasHiddenPagesAfterCurrentPage)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, " ... "))
              : _createCommentVNode("", true),
            (_ctx.canShowLastPage)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 5,
                  class: "pagination__item pagination__num",
                  href: "#",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.goToLastPage()), ["stop","prevent"]))
                }, _toDisplayString(_ctx.totalPages), 1))
              : _createCommentVNode("", true),
            (_ctx.hasHiddenPagesAfterCurrentPage)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 6,
                  class: "pagination__item pagination__arrow-next",
                  href: "#",
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.goToNextPage()), ["stop","prevent"]))
                }, _hoisted_13))
              : _createCommentVNode("", true),
            (_ctx.hasHiddenPagesAfterCurrentPage)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 7,
                  class: "pagination__item pagination__arrow-last",
                  href: "#",
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.goToLastPage()), ["stop","prevent"]))
                }, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createVNode(_component_i18n_t, { keypath: "pagination.show" }),
                _createTextVNode(" : ")
              ]),
              _createVNode(_component_app_dropdown, {
                modelValue: _ctx.perPageModel,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.perPageModel) = $event)),
                type: 'single',
                "show-checkbox": false,
                options: _ctx.perPageOptions,
                "get-value": (option) => option.value,
                "get-label": (option) => option.label
              }, null, 8, ["modelValue", "options", "get-value", "get-label"])
            ])
          ])
        ])
      ], 2))
    : _createCommentVNode("", true)
}